import React, { useState } from "react";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import CircularProgress from "@mui/material/CircularProgress";
import { suggestReply, toggleAutoReply } from "./inboxApi";

export default function AISuggestions({ conversationId, autoReplyEnabled, onInsert, onAutoReplyToggle }) {
  const [suggestions, setSuggestions] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleSuggest = async () => {
    if (!conversationId) return;
    setLoading(true);
    try {
      const data = await suggestReply(conversationId);
      setSuggestions(data.suggestions || []);
    } catch {
      setSuggestions(["Could not generate suggestions."]);
    } finally {
      setLoading(false);
    }
  };

  const handleToggle = async () => {
    if (!conversationId) return;
    try {
      await toggleAutoReply(conversationId);
      onAutoReplyToggle?.();
    } catch { /* ignore */ }
  };

  return (
    <div style={{ padding: "10px 14px", borderTop: "1px solid #e2e8f0" }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 8 }}>
        <button
          type="button"
          onClick={handleSuggest}
          disabled={loading || !conversationId}
          style={{
            display: "flex",
            alignItems: "center",
            gap: 4,
            border: "1px solid #e2e8f0",
            borderRadius: 8,
            padding: "5px 10px",
            background: "#faf5ff",
            color: "#7c3aed",
            fontSize: 13,
            fontWeight: 600,
            cursor: "pointer",
          }}
        >
          {loading ? (
            <CircularProgress size={14} />
          ) : (
            <AutoAwesomeIcon sx={{ fontSize: 16 }} />
          )}
          Suggest Reply
        </button>

        <label style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 12, color: "#64748b", cursor: "pointer" }}>
          Auto Reply
          <input
            type="checkbox"
            checked={!!autoReplyEnabled}
            onChange={handleToggle}
            style={{ width: 16, height: 16, accentColor: "#7c3aed" }}
          />
        </label>
      </div>

      {suggestions.length > 0 && (
        <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
          {suggestions.map((s, i) => (
            <button
              key={i}
              type="button"
              onClick={() => {
                onInsert(s);
                setSuggestions([]);
              }}
              style={{
                textAlign: "left",
                border: "1px solid #e2e8f0",
                borderRadius: 8,
                padding: "6px 10px",
                background: "#fff",
                cursor: "pointer",
                fontSize: 13,
                lineHeight: 1.4,
                color: "#334155",
                transition: "background 0.15s",
              }}
            >
              {s}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
